"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fonts = void 0;
require("@fontsource/rubik/300.css");
require("@fontsource/rubik/400.css");
require("@fontsource/rubik/500.css");
require("@fontsource/rubik/600.css");
require("@fontsource/rubik/700.css");
require("@fontsource/rubik/800.css");
exports.fonts = {
    heading: "Rubik, sans-serif",
    body: "Rubik, sans-serif",
};
